import i18n from '../i18n';

export function getPresentationLanguage() {
  return String(i18n.resolvedLanguage || i18n.language || 'es').split('-')[0];
}

export function localizedValue(values, fallback = '') {
  const language = getPresentationLanguage();
  return values?.[language] ?? values?.es ?? values?.en ?? fallback;
}

export function isEnglishPresentation() {
  return getPresentationLanguage() === 'en';
}

export function localizedServerContent(content, englishFallback = '') {
  return isEnglishPresentation() ? englishFallback : (content || englishFallback);
}
